import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/cA-logo.svg'


const _hoisted_1 = { class: "p-d-flex p-jc-between p-ai-end" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "logo p-d-flex p-ai-center" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, "Code Awareness")
], -1)
const _hoisted_3 = { class: "nav-right p-d-flex p-ai-center" }
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createElementVNode("img", {
          src: $setup.user.avatar
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("span", null, _toDisplayString($setup.user.email), 1)
      ]),
      _createVNode(_component_Dropdown, {
        modelValue: $setup.locale,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.locale) = $event)),
        options: $setup.locales,
        optionLabel: "lang",
        onChange: $setup.switchLanguage
      }, null, 8, ["modelValue", "options", "onChange"])
    ])
  ]))
}